// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O44L","title":"styles_title__hmoKl"};